import bridge from '@vkontakte/vk-bridge';
import { areNotificationsEnabled } from './launchParams';

/**
 * Ask the user to allow mini-app / game notifications.
 * Returns true if permission is granted (or already was, when checked first).
 */
export async function requestAllowNotifications(): Promise<boolean> {
  if (await areNotificationsEnabled()) {
    return true;
  }
  try {
    const data = await bridge.send('VKWebAppAllowNotifications');
    return data.result === true;
  } catch {
    return false;
  }
}
